import { cva } from 'class-variance-authority';

export const radioInputStyles = cva('appearance-none w-6 h-6 border rounded-full relative', {
  variants: {
    checked: {
      true: 'bg-white border-blue-300 before:content-[""] before:block before:w-3 before:h-3 before:bg-blue-300 before:rounded-full before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2',
      false: 'border-neutral-400',
    },
    disabled: {
      true: 'cursor-not-allowed bg-grey-200 border-neutral-400',
      false: 'cursor-pointer',
    },
  },
  defaultVariants: {
    checked: false,
    disabled: false,
  },
});
